import { useState } from "react";
import { submitJoin } from "@/lib/api";

const ROLES = [
  "Growing food",
  "Preparing food",
  "Sharing or selling food",
  "Researching or teaching",
  "Working in an organisation or government",
  "Something else",
];
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const JoinForm = () => {
  const [state, setState] = useState("idle");

  const onSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const email = form.elements.email;
    email.setCustomValidity(email.value && !EMAIL_RE.test(email.value.trim()) ? "Please enter a valid email address." : "");
    if (!form.checkValidity()) { form.reportValidity(); return; }
    setState("sending");
    try {
      await submitJoin(Object.fromEntries(new FormData(form)));
      setState("sent");
    } catch {
      setState("error");
    }
  };

  return (
    <form className={state === "sent" ? "join-form sent" : "join-form"} id="join-form" noValidate onSubmit={onSubmit} data-testid="join-form">
      <div className="fields">
        <label>Name
          <input name="name" autoComplete="name" required data-testid="join-name-input" />
        </label>
        <label>Email
          <input name="email" type="email" autoComplete="email" required onInput={(e) => e.target.setCustomValidity("")} data-testid="join-email-input" />
        </label>
        <label>Where are you based?
          <input name="place" placeholder="District or city" data-testid="join-place-input" />
        </label>
        <label>I am mostly
          <select name="role" data-testid="join-role-select">
            {ROLES.map((r) => <option key={r}>{r}</option>)}
          </select>
        </label>
        <label>Anything you would like to tell us (optional)
          <textarea name="message" rows="4" data-testid="join-message-input" />
        </label>
        <div className="visually-hidden" aria-hidden="true">
          <label>Website
            <input name="website" tabIndex={-1} autoComplete="off" data-testid="join-honeypot-input" />
          </label>
        </div>
        <button className="btn" type="submit" disabled={state === "sending"} data-testid="join-submit-button">Join the network</button>
        <p className="form-note">We write only when there is something worth sharing. We never pass on your details.</p>
        {state === "error" && (
          <p className="form-note" role="alert" data-testid="join-error-message">
            Something went wrong. Please try again, or email hello@nepalfood.org.
          </p>
        )}
      </div>
      <p className="form-done" role="status" data-testid="join-success-message">Thank you. You are now part of the network, and we will be in touch.</p>
    </form>
  );
};
